import { render, staticRenderFns } from "./MenuTukang.vue?vue&type=template&id=566594d7&scoped=true&"
import script from "./MenuTukang.vue?vue&type=script&lang=js&"
export * from "./MenuTukang.vue?vue&type=script&lang=js&"
import style0 from "./MenuTukang.vue?vue&type=style&index=0&id=566594d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566594d7",
  null
  
)

export default component.exports